import apiClient from './apiConfig';

export const blogsApi = {
  // Lấy tất cả blogs (API trả về { blogs, total, page, totalPages })
  getAllBlogs: async (params = {}) => {
    try {
      const response = await apiClient.get('/blogs', { params });
      // API trả về { blogs, total, page, totalPages } — trả lại mảng blogs cho backward compat
      const data = response.data;
      return Array.isArray(data) ? data : (data.blogs || []);
    } catch (error) {
      console.error('Error fetching blogs:', error);
      throw error;
    }
  },

  // Lấy blog theo ID
  getBlogById: async (id) => {
    try {
      const response = await apiClient.get(`/blogs/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching blog:', error);
      throw error;
    }
  },

  // Tạo blog mới
  createBlog: async (blogData) => {
    try {
      const response = await apiClient.post('/blogs', blogData);
      return response.data;
    } catch (error) {
      console.error('Error creating blog:', error);
      throw error;
    }
  },

  // Cập nhật blog
  updateBlog: async (id, blogData) => {
    try {
      const response = await apiClient.put(`/blogs/${id}`, blogData);
      return response.data;
    } catch (error) {
      console.error('Error updating blog:', error);
      throw error;
    }
  },

  // Xóa blog
  deleteBlog: async (id, authorId) => {
    try {
      const response = await apiClient.delete(`/blogs/${id}`, {
        data: { authorId }
      });
      return response.data;
    } catch (error) {
      console.error('Error deleting blog:', error);
      throw error;
    }
  },

  // Cập nhật trạng thái blog
  updateBlogStatus: async (id, statusData) => {
    try {
      const response = await apiClient.put(`/blogs/${id}/status`, statusData);
      return response.data;
    } catch (error) {
      console.error('Error updating blog status:', error);
      throw error;
    }
  },

  // Lấy blogs đã xuất bản (public)
  getPublishedBlogs: async (params = {}) => {
    try {
      const response = await apiClient.get('/blogs/public/published', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching published blogs:', error);
      throw error;
    }
  },

  // Lấy blog theo slug
  getBlogBySlug: async (slug) => {
    try {
      const response = await apiClient.get(`/blogs/slug/${slug}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching blog by slug:', error);
      throw error;
    }
  },

  // Tăng view count
  incrementView: async (id) => {
    try {
      const response = await apiClient.patch(`/blogs/${id}/view`);
      return response.data;
    } catch (error) {
      console.error('Error incrementing view:', error);
      throw error;
    }
  },

  // Lấy bài viết liên quan
  getRelatedBlogs: async (slug) => {
    try {
      const response = await apiClient.get(`/blogs/public/related/${slug}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching related blogs:', error);
      throw error;
    }
  }
};
